import { DesignatedDoctorInformation } from "./DesignatedDoctorInformation";

export class UserDetail {
  constructor(
    public readonly designatedDoctorNos: DesignatedDoctorInformation[],
    public readonly comment: string,
    public readonly updateUserName: string,
    public readonly updateDateTime: string,
  ) {
  }
}
